

const limitSwatches = (container) => {
  if (container == null)
    return;
  if (container.children.length > 0) {
    for (let i = 0; i < container.children.length; i++) {
      container.children[i].style.display = "none";
    }

    const newPara = document.createElement('p');
    newPara.classList.add('more-swatches-text');
    const newText = document.createTextNode(`${container.children.length} colours available`);
    newPara.appendChild(newText);

    container.appendChild(newPara);
  }
};

function update_sku_category_updateAddToCartState(variant) {

  const lens_category_rating_container = document.querySelector('#lens-category-rating-container');
  const product_sku_detail_container = document.querySelector('#product-sku-detail-container');

  if (typeof array_lens_category_rating !== 'undefined') {
    var variant_lens_category_rating = array_lens_category_rating[variant.id];
    var variant_sku = variant.sku;

    if (lens_category_rating_container) {
      if (variant_lens_category_rating == 'null') {
        lens_category_rating_container.classList.add("disable");
      } else {
        lens_category_rating_container.classList.remove("disable");
        lens_category_rating_container.getElementsByClassName("lens-category-rating")[0].textContent = variant_lens_category_rating;
      }
    }
    if (product_sku_detail_container) {
      product_sku_detail_container.getElementsByClassName("product-sku-detail")[0].textContent = variant_sku;
    }
  }
}

function update_variant_title_html(variant) {

  var variant_title_htmls = document.querySelectorAll(".product_variant__title");
  variant_title_htmls.forEach((element) => {
    element.innerText = variant.title;
  })

}

function setLinkAttribute() {
  console.log('setLinkAttribute ------------------------------------------ ');
}

document.addEventListener('DOMContentLoaded', () => {
  let productRemoveBtns = document.querySelectorAll('.cart [data-item-remove]');

  productRemoveBtns.forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      let pair_item_id = item.getAttribute('data-pair-id');

      let items_id_array = [item.getAttribute('data-id')];

      if (pair_item_id) {
        items_id_array = [item.getAttribute('data-id'), pair_item_id];
      }

      let formData = {
        'updates': {}
      };

      for (var i = 0; i < items_id_array.length; i++) {
        formData['updates'][parseInt(items_id_array[i])] = 0;
      }

      let info = fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(response => {
          window.location.reload();
        }).catch((error) => {
          console.error('Error:', error);
        });
    })
  })
})

$(document).ready(function () {
  $('.prev-product-preview').click(function () {
    $(this).closest(".main_contents").find('.close_dialog_button').trigger('click');
    console.log(selected_element);
    let current_grid_item = $(selected_element).closest('.product-grid-item');

    while (1) {
      console.log($(current_grid_item).prev().length);
      if ($(current_grid_item).prev().length > 0) {
        if ($(current_grid_item).prev().find('.plattar_vto_dialog_open_button').length <= 0) {
          current_grid_item = $(current_grid_item).prev()
        }
        else {
          break;
        }
      }
      else {
        return;
      }
    }
    $(current_grid_item).prev().find('.plattar_vto_dialog_open_button').trigger('click');
  });
  $('.next-product-preview').click(function () {
    console.log(selected_element);
    $(this).closest(".main_contents").find('.close_dialog_button').trigger('click');
    let current_grid_item = $(selected_element).closest('.product-grid-item');

    while (1) {
      console.log($(current_grid_item).next().length);
      if ($(current_grid_item).next().length > 0) {
        if ($(current_grid_item).next().find('.plattar_vto_dialog_open_button').length <= 0) {
          current_grid_item = $(current_grid_item).next()
        }
        else {
          break;
        }
      }
      else {
        return;
      }
    }
    $(current_grid_item).next().find('.plattar_vto_dialog_open_button').trigger('click');
  });
})